import React, { useState } from 'react'
import { RiWallet3Fill } from 'react-icons/ri'
import './Wallet.css'
import WalletController from './WalletController'
import { ToastContainer } from 'react-toastify';

function Wallet() {
  const {handleAddMoney,setAmount,amount,payLoading,balance,setBalance,wallet,book} = WalletController();

  return (
    <>
      <div className="wallet-wrapper">
      
        <div className="wallet-icon">
          <span className="wallet-balance" style={{fontSize:"18px",marginRight:"8px"}}>{wallet.walletAmount}</span>
          <RiWallet3Fill color="green" size={24}/>
          <stan style={{fontSize:"18px",marginRight:"8px"}}>Wallet</stan>
        </div>

        <div className="wallet-popup">
          <input 
            type="text" 
            className="form-control" 
            value={amount}
            onChange={(e)=>setAmount(e.target.value)}
            placeholder="Enter amount"
          />
          <button className="btn btn-primary mt-1" disabled={payLoading} 
          onClick={handleAddMoney}
          style={{width:'100%'}}
          >
            {payLoading?'processing..':'Add Money'}
          </button>
        </div>
      </div>
      <ToastContainer
      position="top-right"
      style={{ top: "20px", right: "40px" }}/>
      {/* <div >
        <input type='text' className='form-control' value={balance} onChange={(e)=>setBalance(e.target.value)}/>
        <button className='btn btn-primary mt-2' disabled={payLoading} onClick={book}>Book</button>
      </div> */}
    </>
  )
}

export default Wallet
